import { useProfilROBReklamaceContextInstance } from '@gov-nx/module/page';
import {
	commonSelectPropsToSelectProps,
	FormInput,
	FormSelect,
} from '@gov-nx/ui/web';

export const BirthPlaceChangeForm = () => {
	const { formDefinition } = useProfilROBReklamaceContextInstance();
	const { form } = formDefinition;

	if (!formDefinition.hasCountriesOptions) {
		return null;
	}
	return (
		<>
			<FormSelect {...commonSelectPropsToSelectProps(form.fields.stat)} />
			<FormInput {...form.fields.newPlaceOfBirth} />
		</>
	);
};
